<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
             Department of Agri Product Sale and Marketing/ ຕະຫຼາດ
            
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid==6 || roleid==7">
        <b-tab-item label="ຟອມເພີ່ມ/ ແກ້ໄຂຕະຫຼາດ" v-if="adddataform && !isopentime">
         <div class="columns" >
            <div class="column">
              <h3 class="title">ເພິ່ມ/ ແກ້ໄຂຕະຫຼາດ {{ selectedMarketName }}</h3>
            </div>
          </div>
          <div class="columns" >
            <div class="column">
              <div class="columns">
                <div class="column">
                  <b-field label="ຊື່ຕະຫຼາດ">
                    <b-input v-model.trim="marketname"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ແຂວງ">
                    <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedProvince"
                    label="NAME"
                    track-by="ID"
                    :options="provinceList"
                  >
                  </Multiselect>
                  </b-field>
                </div>
                
                <div class="column">
                  <b-field label="ເມືອງ">
                    <b-input v-model.trim="district"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ບ້ານ">
                    <b-input v-model.trim="village"> </b-input>
                  </b-field>
                </div>
              </div>
             
              <b-field label="" style="float: right">
                <b-field v-if="saveAction">
                  <button class="button is-info" @click="saveForm">
                    ບັນທຶກ
                  </button>
                </b-field>
                <b-field v-if="updateAction">
                  <div class="columns">
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-primary"
                          @click="updateMarket"
                        >
                          ແກ້ໄຂ
                        </button>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-info"
                          @click="openSaveMarketForm"
                        >
                          ຟອມເພີ່ມຕະຫຼາດ
                        </button>
                      </b-field>
                    </div>
                  </div>
                </b-field>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ເວລາເປີດ ຕະຫຼາດ"  v-if="isopentime"> 
          <div class="columns" >
            <div class="column">
              <h3 class="title">ເວລາເປີດ-ປິດ {{ selectedMarketName }}</h3>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="columns">
                <b-field label="ວັນທີ">
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="selecteddate"
                      >
                      </b-datepicker>
                    </b-field>
              </div>
              <br>
              <div class="columns">
                <b-field label="ເວລາເປີດ">
                  <Multiselect
                    placeholder="ເລືອກເວລາເປີດ"
                    v-model.trim="selectedopentime"
                    label="TIME"
                    track-by="TIME"
                    :options="timeList"
                  >
                  </Multiselect>
                </b-field>
              </div>
              <br>
              <div class="columns">
                <b-field label="ເວລາປິດ">
                  <Multiselect
                    placeholder="ເລືອກເວລາປິດ"
                    v-model.trim="selectedclosetime"
                    label="TIME"
                    track-by="TIME"
                    :options="timeList"
                  >
                  </Multiselect>
                </b-field>
              </div>
              <div class="columns">
                <b-field>
                <button
                  class="button is-info"
                  @click="saveMarketTime"
                >
                  ບັນທຶກ
                </button>
                      </b-field>
              </div>
              
            </div>
            <div class="column">
                <b-field label="ຕາຕະລາງເປີດ-ປິດຕະຫຼາດ">
                  <table 
                    class="table is-fullwidth "
                  >
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="45%">
                          ວັນທີ
                        </th>
                        <th class="has-text-left " width="25%">
                          ເວລາເປີດ
                        </th>
                        <th class="has-text-left " width="25%">
                          ເວລາປິດ
                        </th>                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in marketopenclosetime"
                        :key="data.ID"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>
                          {{ dateFormatter(data.MARKETDATE) }}
                        </td>
                        <td>
                          {{ data.OPENTIME }}
                        </td>
                        <td>
                          {{ data.CLOSETIME }}
                        </td>
                        
                        
                      </tr>
                    </tbody>
                  </table>
                </b-field>
            </div>
          </div>

        </b-tab-item>

        <b-tab-item label="ຕະຫຼາດ ເປີດໃຊ້ງານ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ຕະຫຼາດ ເປີດໃຊ້ງານ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="30%">
                        ບ້ານ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activemarkets"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>
                     
                      <td class="has-text-centered">
                          <b-field group>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  updateForm(
                                    data.ID,
                                    data.MARKETNAME,
                                    data.PROVINCEID,
                                    data.PROVINCENAME,
                                    data.DISTRICT,
                                    data.VILLAGE
                                  )"
                                >ແກ້ໄຂ
                              </b-button>
                            </b-field>
                            <b-field v-if="data.IS24 !=1">
                              <b-button class="btn-group-margin"
                                type="is-info"
                                size="is-small"
                                @click="
                                  opentimeForm(
                                    data
                                  )"
                                >ເວລາເປີດ-ປິດ ຕະຫຼາດ
                              </b-button>
                            </b-field>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="
                                  changeSataus(data.ID,0)"
                                >ປິດໃຊ້ງານ
                              </b-button>
                            </b-field>
                          </b-field>
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        
        <b-tab-item label="ຕະຫຼາດ ທີ່ຖືກປິດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ຕະຫຼາດ ທີ່ຖືກປິດ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="30%">
                        ບ້ານ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in inactivemarkets"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>
                      <td>
                        <b-field>
                              <b-button class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              changeSataus(data.ID,1)"
                            >ເປີດໃຊ້ງານ
                          </b-button>
                        </b-field>
                      </td>
                      
                      
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  data() {
    return {
    roleid: null,
    userName: null,
    selectedCountry: null,
    countryList: [],
    isProvinceSelected: false,
    selectedProvince: null,
    provinceList:  [],
 
    

    activemarkets: [],
    inactivemarkets: [],
    marketid: null,
    oldmarketname: null,
    marketname: null,
    countryid: null,
    provinceid: null,
    oldprovinceid: null,
    district: null,
    olddistrict: null,
    village: null,
    oldvillage: null,


    activeTab: 1,
    saveAction: true,
    updateAction: false,
    adddataform: true,
    updatedataform: false,
    
    branchUsername: null,
    userProvince: null,
    isopentime: false,
    selectedMartketID: null,
    selectedMarketName: null,
    marketopenclosetime: [],
    selecteddate: null,
    selectedopentime: null,
    selectedclosetime: null,
    timeList: [{"TIME":"05:00"},
               {"TIME":"06:00"},
               {"TIME":"07:00"},
               {"TIME":"08:00"},
               {"TIME":"09:00"},
               {"TIME":"10:00"},
               {"TIME":"11:00"},
               {"TIME":"12:00"},
               {"TIME":"13:00"},
               {"TIME":"14:00"},
               {"TIME":"15:00"},
               {"TIME":"16:00"},
               {"TIME":"17:00"},
               {"TIME":"19:00"},
               {"TIME":"19:00"},
               {"TIME":"20:00"},
               {"TIME":"21:00"},
               {"TIME":"22:00"},
               {"TIME":"23:00"}
              ],
  };
  },
  methods: {
    getProvince(){
      RestAPI.getProvincebyCountry(1)
        .then(res => {
          // console.log("country ..." + res.data)
          this.provinceList = res.data;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    saveForm() {
      // console.log("this.selectedProvince.ID: " + this.selectedProvince.length)
      console.log("this.selectedProvince.ID : " + this.selectedProvince.ID)
      console.log("this.userProvince : " + this.userProvince)
      if (this.marketname === null || this.selectedProvince === null || this.district === null || this.village === null  ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else if(this.roleid == 7 && this.selectedProvince.ID != this.userProvince){ 
         this.$swal("ກະລຸນາເລືຶອກແຂວງ ທີ່ຂຶ້ນກັບຕົນເອງ", "", "error");
      } else {
        var params = {
          marketname: this.marketname,
          provinceid: this.selectedProvince.ID,
          district: this.district,
          village: this.village,
          username: this.username
        };
        RestAPI.saveMarket(params)
          .then(res => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate marketname") {
              this.$swal(
                "ຊື່ຕະຫຼາດຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }


            this.$swal("ສ້າງຕະຫຼາດ ສຳເລັດ!", "", "success");
            
            this.activeTab = 2;
            this.saveAction = true;
            this.updateAction = false;
            this.marketname = null;
            this.selectedProvince = null;
            this.district = null;
            this.village = null;
            this.getMarkets();
            this.activeTab = 1;
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getMarkets() {
      RestAPI.getMarkets(this.branchUsername)
        .then(res => {
          console.log("list:"+ JSON.stringify(res.data))
          this.activemarkets = res.data.activemarkets;
          this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    updateForm(ID, MARKETNAME, PROVINCEID, PROVINCENAME, DISTRICT, VILLAGE) {
     
      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.isopentime = false;
      this.marketid = ID;
      this.oldmarketname =MARKETNAME;
      this.marketname = MARKETNAME;
      this.district = DISTRICT;
      this.village = VILLAGE;
      this.selectedProvince ={"ID": PROVINCEID,"NAME": PROVINCENAME};
      this.selectedMarketName = MARKETNAME;
      
    },
    openSaveMarketForm() {
      this.activeTab = 0;
      this.saveAction = true;
      this.updateAction = false;
      this.isopentime = false;
      this.marketname = null;
      this.selectedProvince = null;
      this.district = null;
      this.village = null;
      this.selectedMarketName = null;
    },
    updateMarket() {
      console.log("this.marketname: "  +this.marketname)
      console.log("this.district: "  +this.district)
      if (this.marketname.length ==0 || this.selectedProvince.length ==0 || this.district.length ==0  || this.village.length ==0) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else if(this.roleid == 7 && this.selectedProvince.ID != this.userProvince){ 
         this.$swal("ກະລຸນາເລືຶອກແຂວງ ທີ່ຂຶ້ນກັບຕົນເອງ", "", "error");
      }else {
        var params = {
        oldmarketname : this.oldbranchname,
        marketid: this.marketid,
        marketname: this.marketname,
        provinceid : this.selectedProvince.ID,
        district : this.district,
        village : this.village,
        username: this.username
      };

      // console.log("pa: " + JSON.stringify(params))
     
      RestAPI.updateMarket(params)
        .then(res => {
          // console.log("data: "+ JSON.stringify(res.data))
          if (res.data == "duplicate marketname") {
            this.$swal(
              "ຊື່ຕະຫຼາດຊ້ຳ",
              "-",
              "error"
            );
            return false;
          }

          this.$swal("ອັບເດດຕະຫຼາດ ສຳເລັດ!", "", "success");

          this.activeTab = 1;
          this.saveAction = true;
          this.updateAction = false;
          this.marketname = null;
          this.selectedProvince = null;
          this.district = null;
          this.village = null;
          this.getMarkets();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
      }
      
    },
    changeSataus(id,status){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            table: "market",
            id: id,
            status: status,
            username: this.username
          };
          RestAPI.changeSataus(params)
            .then(() => {
            
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getMarkets();

            })
            .catch(error => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },
    
    opentimeForm(data) {
     this.isopentime = true;
     this.activeTab = 0;
     this.selectedMartketID = data.ID;
     this.selectedMarketName = data.MARKETNAME;
     this.getMarketOpenCloseTime(data.ID);
      
    }, 

    getMarketOpenCloseTime(marketid){
      RestAPI.getMarketOpenCloseTime(marketid)
          .then(res => {
            console.log("getMarketOpenCloseTime:"+ JSON.stringify(res.data))
            this.marketopenclosetime = res.data;
          })
          .catch(error => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      
      
    },

   saveMarketTime(){
    // console.log("this.selecteddate: " + this.dateFormatterYYYYMMDD(this.selecteddate))
    // console.log("this.selectedopentime: " + this.selectedopentime.TIME)
      if (this.selecteddate === null || this.selectedopentime === null || this.selectedclosetime === null ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          marketid: this.selectedMartketID,
          marketdate: this.dateFormatterYYYYMMDD(this.selecteddate),
          opentime: this.selectedopentime.TIME,
          closetime: this.selectedclosetime.TIME,
          username: this.username
        };
        console.log("f: ", JSON.stringify(params))
        RestAPI.saveMarketTime(params)
          .then(() => {
  
            this.$swal("ເພີ່ມເວລາ ສຳເລັດ!", "", "success");
            
            this.selecteddate = null;
            this.selectedopentime = null;
            this.selectedclosetime = null;
            this.getMarketOpenCloseTime(this.selectedMartketID);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
   },

    print() {
      window.print();
    },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvince = this.user.BSMPROVINCEID;
    this.branchUsername = this.user.ROLEID == 6 ? 'ALL' : this.user.USERNAME,
    this.getMarkets();
    this.getProvince();
    this.selecteddate = new Date();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
